import Udesk from 'Udesk';
import UdeskLocales from 'UdeskLocales';
import React, { forwardRef, useMemo } from 'react';
import { Button, Icon, Space } from 'udesk-ui';
import { ContentHeader, RoleTag } from './components';
import XssComponent from 'udesk-react/src/components/xss';
import Ellipsis from 'src/components/common/Ellipsis';
import { replaceLineBreak } from 'src/util/text-replace';
import { safeParse } from 'src/util/safeParse';

interface TemplateProps {
    item?: any;
    content?: any;
    titleRef?: any;
}

const Template = forwardRef((props: TemplateProps, ref: any) => {
    const { item, content, titleRef } = props;

    const locales = UdeskLocales['current'];

    const { data = {} } = item;

    const reviewAttachments = useMemo(() => safeParse(data.attachment, []), [data.attachment]);

    return (
        <div>
            <ContentHeader>
                <Space>
                    <div style={{ fontWeight: 600 }}>{data.sendUser}</div>
                    <RoleTag sender={data.sender}>
                        {data.sender === 1 || data.sender === '1'
                            ? /* 客户 */ locales.components.ticketTextInfo.index.customer
                            : /* 客服 */ locales.components.ticketTextInfo.index.customerService}
                    </RoleTag>
                </Space>

                <div className="desc" ref={titleRef}>{`${data.createdTime} ${
                    /* 回复至 */ locales.components.ticketTextInfo.index.replyTo
                } ${data.recUser} `}</div>
                <div className="desc">{`${
                    /* 收件人: */ locales.components.ticketTextInfo.index.addressee
                }${data.recEmail}`}</div>
            </ContentHeader>

            <div ref={ref}>
                <XssComponent
                    whiteList={Udesk.ui.widgets.xss.whiteLists.email}
                    value={replaceLineBreak(content)}
                />
            </div>

            <div>
                {(reviewAttachments || []).map((file) => (
                    <div>
                        <Button
                            style={{ padding: 0, width: '100%' }}
                            size="small"
                            type="link"
                            href={file.url}
                            icon={<Icon type="PaperClipOutlined" antdIcon={true} />}
                            target="_blank"
                        >
                            <Ellipsis
                                style={{
                                    width: 'calc(100% - 24px)',
                                    color: '#1b6dff',
                                    fontSize: 12,
                                }}
                                text={file.file_name}
                            />
                        </Button>
                    </div>
                ))}
            </div>
        </div>
    );
});

export default Template;
